<template>
  <div class="member-list">
    <div class="container">  
      <div class="list-outer">  
      
        <div class="list-item">  
          <div class="list-item-image"><img src="http://wku-members.de/wka_personen/20621.jpg"/></div>
          <div class="list-item-caption">
            <div class="list-item-title">Andree Kielholtz</div>
            <div class="list-item-subtitle">20621</div>
          </div>
          <div class="list-item-additionals">
            <div class="list-item-additional"><img src="http://wku-members.de/files/gfx/belt/belt_dan7.jpg"/></div>
            <div class="list-item-additional">Germany</div>
            <div class="list-item-additional"></div>          
          </div>
          
          
        </div> 
       
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'memberList',
  data () {
    return {
      searchText: '',
      eventIndex: 0,
      events:
      [
        {
          location: 'Liberece, Czech Republic',
          title: 'European Martial Arts championship',
          date: '25.05.2017 - 28.05.2017'
        },
        {
          location: 'Liberece 2, Czech Republic',
          title: 'European Martial Arts championship 2',
          date: '25.06.2017 - 28.06.2017'
        }
      ]
    }
  },
  methods: {
    initSearchField: function () {
      this.searchText = ''
    }
  }
}
</script>
